import { render } from "./TramitesProcesados.vue?vue&type=template&id=039bdc1b&scoped=true"
import script from "./TramitesProcesados.vue?vue&type=script&lang=js"
export * from "./TramitesProcesados.vue?vue&type=script&lang=js"

import "./TramitesProcesados.vue?vue&type=style&index=0&id=039bdc1b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039bdc1b"]])

export default __exports__